import { Pipe, PipeTransform } from '@angular/core';
import { MaintenanceStatus } from '@core/interfaces';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'statusMaintenance' })
export class StatusMaintenancePipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }

  transform(statusName: string | MaintenanceStatus): string {
    if (statusName) {
      if (statusName === 'new') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.NEW');
      } else if (statusName === 'pending') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.PENDING');
      } else if (statusName === 'scheduled') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.SCHEDULED');
      } else if (statusName === 'inProgress') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.IN_PROGRESS');
      } else if (statusName === 'done') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.DONE');
      } else if (statusName === 'canceled') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.CANCELED');
      } else if (statusName === 'reported') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.REPORTED');
      } else if (statusName === 'requested') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.REQUESTED');
      } else if (statusName === 'onNegotiation') {
        return this.translateService.instant('MAINTENANCES.STATUS_OPTIONS.ON_NEGOTIATION');
      }
    }
    return null;
  }
}
